module.exports = __webpack_public_path__ + "img/natale.c5addc14.png";